import { __decorate, __metadata } from "tslib";
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { chipStyle } from './chip.style';
let ChipElement = class ChipElement extends LitElement {
    static { this.tagName = 'inch-chip'; }
    static { this.styles = chipStyle; }
    render() {
        return html ` <div class="chip-content">${this.value}</div> `;
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], ChipElement.prototype, "value", void 0);
ChipElement = __decorate([
    customElement(ChipElement.tagName)
], ChipElement);
export { ChipElement };
//# sourceMappingURL=chip.element.js.map